@if (status === 'empty') {
  <p class="empty-list-info">
    {{ 'CAMPAIGN.ACCOUNTS.EMPTY_PAGE_LN' | translate }}
  </p>
}

<button class="btn add-account-btn" [disabled]="lockActions$ | async" (click)="onAddAccountClick()">
  <svg width="20" height="20" class="icon">
    <use xlink:href="#bold-plus"></use>
  </svg>
  {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_BUTTON' | translate }}
</button>

@if (list$ | async; as list) {
  <div class="table-wrapper">
    <div class="background-box box"></div>
    @if (status === 'received') {
      <div class="pseudo-table">
        <span class="title">{{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.STATUS' | translate }}</span>
        <span class="title">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ACCOUNT_NAME' | translate }}
        </span>
        <span class="title">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.PROFILE_VIEWS' | translate }}
        </span>
        <span class="title">{{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIKES' | translate }}</span>
        <span class="title">{{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.MESSAGES' | translate }}</span>
        <span class="title title-connection">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.CONNECTION_REQUESTS' | translate }}
        </span>
        <span class="title">{{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.IN_MAIL' | translate }}</span>
        <span class="title">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.WITHDRAW_LIMIT' | translate }}
        </span>
        <span class="title"></span>
        @for (credendtial of list; track credendtial.id) {
          <app-account-status
            class="status"
            [accountState]="credendtial?.status"></app-account-status>
          <div class="name-block">
            @if (credendtial.enable && credendtial?.plan !== 'Free') {
              <p class="account-plan">
                {{ credendtial?.plan }}
              </p>
            }
            <p class="name">{{ credendtial.name }}</p>
          </div>
          <span class="views">{{ credendtial.restOfViews }} / {{ credendtial.views }}</span>
          <span class="likes">{{ credendtial.restOfLikes }} / {{ credendtial.likes }}</span>
          <span class="messages">
            {{ credendtial.restOfMessages }} / {{ credendtial.messages }}
          </span>
          <span class="connection-requests">
            {{ credendtial.restOfRequests }} / {{ credendtial.requests }}
          </span>
          <span class="in-mail"> {{ credendtial.restOfInMail }} / {{ credendtial.inMail }} </span>
          <span class="withdraw-limit">{{ credendtial.withdrawLimit }}</span>
          @if (credendtial.status !== 'PENDING') {
            <app-edit-actions
              class="actions"
              (reconnect)="reconnect(credendtial)"
              (editLimits)="editLimits(credendtial)"
              (editPrivacy)="editPrivacy(credendtial)"
              (delete)="delete(credendtial)"
              (toggleEnable)="toggleAccountEnable($event)"
              [disabled]="lockActions$ | async"
              [disableReconnect]="credendtial.status === 'ACTIVE'"
              [id]="credendtial.id"
              [isAccountEnabled]="credendtial.enable"
              [isAccountAccessible]="credendtial.canAccessPersonally"></app-edit-actions>
          }
        }
      </div>
    }
  </div>
}
